<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="w-full h-full">
    <path fill="currentColor" d="M9.5 4A6.5 6.5 0 0 0 3 10.5a6.5 6.5 0 0 0 2.6 5.2L5 17v2l2-1.2c.9.4 1.9.7 3 .7 5.2 0 9.5-4.3 9.5-9.5S14.7 4 9.5 4zm0 15c-1.1 0-2.1-.2-3-.6l-1.2-.6-1.2.6.6-1.2-.6-1.2A6.5 6.5 0 0 1 9.5 7C13.6 7 17 10.4 17 14.5S13.6 22 9.5 22z"/>
  </svg>
</template>
